module.exports = __webpack_public_path__ + "static/paint-3f84ede96324146748cd8ed4bee73371.png";